import { Injectable } from '@angular/core';
import { MorphboxElement } from '@models/Sessions/Morphbox/Element';
import { Morphbox } from '@models/Sessions/Morphbox/Morphbox';
import { Row } from '@models/Sessions/Morphbox/Row';
import { Session } from '@models/Sessions/Session';

import { BusService } from '../bus.service';
import { EventsService } from '../events.service';
import { RequestService } from '../request.service';

@Injectable()
export class SessionMorphboxRequestService {
  api = {
    root: '/session',
    morphbox: '/morphboxes',
    row: '/rows',
    element: '/elements',
  };

  constructor(
    private client: RequestService,
    private bus: BusService,
    private events: EventsService,
  ) {
    this.subscribe();
  }

  addRow(row: Row, morphbox: Morphbox, session: Session) {
    this.client.post<any, any>({
      uri:
        this.api.root +
        `/${session._id}` +
        this.api.morphbox +
        `/${morphbox._id}` +
        this.api.row,
      body: row,
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.failure,
            error.error,
          ),
      },
    });
  }

  deleteRow(row: Row, morphbox: Morphbox, session: Session) {
    this.client.delete<any>({
      uri:
        this.api.root +
        `/${session._id}` +
        this.api.morphbox +
        `/${morphbox._id}` +
        this.api.row +
        `/${row._id}`,
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.failure,
            error.error,
          ),
      },
    });
  }

  addElement(
    element: MorphboxElement,
    row: Row,
    morphbox: Morphbox,
    session: Session,
  ) {
    this.client.post<any, any>({
      uri:
        this.api.root +
        `/${session._id}` +
        this.api.morphbox +
        `/${morphbox._id}` +
        this.api.row +
        `/${row._id}` +
        this.api.element,
      body: element,
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addElement.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addElement.failure,
            error.error,
          ),
      },
    });
  }

  deleteElement(
    element: MorphboxElement,
    row: Row,
    morphbox: Morphbox,
    session: Session,
  ) {
    this.client.delete<any>({
      uri:
        this.api.root +
        `/${session._id}` +
        this.api.morphbox +
        `/${morphbox._id}` +
        this.api.row +
        `/${row._id}` +
        this.api.element +
        `/${element._id}`,
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.session.morphbox.addRow.failure,
            error.error,
          ),
      },
    });
  }

  private subscribe() {
    this.bus.subscribe(
      this.events.requested.action.session.morphbox.addRow,
      this.addRow.bind(this),
    );
    this.bus.subscribe(
      this.events.requested.action.session.morphbox.deleteRow,
      this.deleteRow.bind(this),
    );
    this.bus.subscribe(
      this.events.requested.action.session.morphbox.addElement,
      this.addElement.bind(this),
    );
    this.bus.subscribe(
      this.events.requested.action.session.morphbox.deleteElement,
      this.deleteElement.bind(this),
    );
  }
}
